import { render, staticRenderFns } from "./DailyReport.vue?vue&type=template&id=28f890af&"
import script from "./DailyReport.vue?vue&type=script&lang=js&"
export * from "./DailyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f890af')) {
      api.createRecord('28f890af', component.options)
    } else {
      api.reload('28f890af', component.options)
    }
    module.hot.accept("./DailyReport.vue?vue&type=template&id=28f890af&", function () {
      api.rerender('28f890af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/reports/DailyReport.vue"
export default component.exports